import classNames from "classnames";
import styles from "./AscFiltersCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import AscParagraph from "../../AscTypography/AscParagraph/AscParagraph";
import AscButton from "../../AscButton/AscButton";
import AscTextInput from "../../AscInputFields/AscTextInput/AscTextInput";
import AscCheckBox from "../../AscInputFields/AscCheckBox/AscCheckBox";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";

export interface AscFiltersCardProps {
  className?: string;
  handlerFilters?: any;
  resetFilters?: () => void;
  filteredOptions?: string[];
}

export default function AscFiltersCardCompany({
  className,
  filteredOptions,
  handlerFilters,
  resetFilters,
}: AscFiltersCardProps) {
  const router = useRouter();
  const [jobCategories, setJobCategories] = useState<string[]>([]);
  useEffect(() => {
    if (router.query.internshipType) {
      setJobCategories(String(router.query.internshipType).split(","));
    }
  }, [router.query.internshipType]);

  const jobTypeHandler = (categoryName: string) => {
    const updatedFilters = [...jobCategories];

    if (updatedFilters.includes(categoryName)) {
      const index = updatedFilters.indexOf(categoryName);
      updatedFilters.splice(index, 1);
    } else {
      updatedFilters.push(categoryName);
    }
    setJobCategories(updatedFilters);
    const payload = { internshipType: updatedFilters };
    handlerFilters(payload);
  };
  const handleClear = () => {
    if (resetFilters) {
      resetFilters();
    }
    setJobCategories([]);
  };
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      title={null}
      coverImageUrl={null}
    >
      <div className={styles.header}>
        <AscParagraph className={styles.title}>Filters</AscParagraph>
        {router.query.keyword ||
        jobCategories.length > 0 ||
        router.query.isRemote === "true" ||
        router.query.minBonus ||
        router.query.maxBonus ? (
          <AscButton
            variant="link"
            hideLinkIcon
            className={styles.clear}
            onClick={handleClear}
          >
            Clear
          </AscButton>
        ) : null}
      </div>
      <div className={styles.content}>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Keyword</AscParagraph>
          <AscTextInput
            placeholder="Company, location..."
            value={router.query.keyword || ""}
            onChange={(e) => handlerFilters({ keyword: e.target.value })}
          />
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Bonuses</AscParagraph>
          <div className={styles.dropDownsWrapper}>
            <AscTextInput
              placeholder="$ Min"
              className={styles.maxBonusInput}
              value={router.query.minBonus || ""}
              onChange={(e) => handlerFilters({ minBonus: e.target.value })}
            />
            <AscTextInput
              placeholder="$ Max"
              value={router.query.maxBonus || ""}
              onChange={(e) => handlerFilters({ maxBonus: e.target.value })}
            />
          </div>
        </div>
        <div className={styles.filterItem}>
          <div className={styles.checkbox}>
            <AscCheckBox
              checked={router.query.isRemote === "true"}
              onChange={() => {
                const newIsRemote = router.query.isRemote !== "true";
                handlerFilters({ isRemote: newIsRemote });
              }}
            />
            <AscParagraph className={styles.checkboxLabel}>
              Remote OK
            </AscParagraph>
          </div>
        </div>
        <div className={styles.filterItem}>
          <AscParagraph className={styles.label}>Internship Type</AscParagraph>
          <div className={styles.filterCheckboxes}>
            {filteredOptions?.map((categoryType, index) => {
              const words = categoryType.split("_");
              const formattedCategory = words
                .map(
                  (word) =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                )
                .join(" ");
              return (
                <div className={styles.filterCheckbox} key={index}>
                  <AscCheckBox
                    checked={jobCategories.includes(categoryType)}
                    onChange={() => jobTypeHandler(categoryType)}
                  />
                  <AscParagraph className={styles.checkboxLabel}>
                    {formattedCategory}
                  </AscParagraph>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </AscGenericCard>
  );
}
